module.exports = __webpack_public_path__ + "img/QRcode.1266a7df.png";